<style scoped>
.button-groups {
  display: flex;
  justify-content: center;
  margin-bottom: 50px;
  margin-top: 50px;
}
.map-a-sty {
  width: 90px;
  height: 28px;
  line-height: 28px;
  color: #4fa1a4;
  margin-top: 5px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #4fa1a4;
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
}
.content {
  margin: 0px;
}
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
.costApprove {
  text-align: left;
  background: #fff;
  margin: 16px;
  padding: 20px 30px;
  display: flow-root;
}

.cost-title {
  height: 72px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.cost-title .flow-name {
  color: #323233;
  font-size: 20px;
}
.cost-title .task-tips {
  margin-left: 20px;
}
.cost-title .flow-back {
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  color: #323233;
  padding: 0 26px;
  border: 1px solid #c8c9cd;
  cursor: pointer;
}
.cost-title-list {
  display: flex;
  align-items: center;
  height: 32px;
  line-height: 32px;
  padding-left: 20px;
  background: #f6f7fa;
}
.cost-title-list-line {
  display: inline-block;
  width: 6px;
  height: 14px;
  background: #4fa1a4;
}
.cost-title-list-txt {
  font-size: 18px;
  color: #323233;
  padding-left: 6px;
}
.cost-approve-list {
  display: flex;
  margin: 18px 0;
  position: relative;
  margin-bottom: 10px;
  width: 860px;
}
.cost-approve-list .tips {
  position: absolute;
  color: red;
  font-size: 12px;
  bottom: -6px;
  left: 145px;
}

.cost-approve-list-title {
  width: 145px;
  text-align: right;
  flex-shrink: 0;
  line-height: 40px;
  padding-left: 25px;
  box-sizing: border-box;
}
.cost-approve-list-content {
  flex: 1;
}
.cost-submit-btn {
  display: flex;
  justify-content: center;
  /* padding: 50px 0; */
  padding-bottom: 20px;
}
.cost-submit-btn-sure {
  color: #fff;
  width: 112px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #4fa1a4;
  cursor: pointer;
  margin-left: 20px;
}
.cost-submit-btn-cancel {
  color: #fff;
  width: 112px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #c8c9cc;
  cursor: pointer;
}
.cost-approve-list-content a {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
  line-height: 40px;
}
.cost-header {
  display: flex;
  background: #f0f0f0;
  font-size: 12px;
  border-right: 1px solid #dfdfdf;
}
.cost-header .header-child {
  flex: 1;
  padding: 10px;
  border-right: 1px solid #dfdfdf;
}
.cost-header .header-child:last-child {
  border-right: 0 none;
}
.cost-wrap {
  border: 1px solid #dfdfdf;
  border-right: 0 none;
}
.cost-list-content {
  display: flex;
  border-bottom: 1px solid #dfdfdf;
}
.cost-list-content:last-child {
  border-bottom: 0 none;
}
.cost-list-content .header-child {
  flex: 1;
  padding: 10px;
  display: flex;
  align-items: center;
  border-right: 1px solid #dfdfdf;
}
.cost-list-content .add {
  color: #4fa1a4;
  cursor: pointer;
}
.cost-list-content .del {
  color: #d0021b;
  cursor: pointer;
}
.header-select span {
  margin-left: 6px;
}
.cost-row {
  display: flex;
}
.cost-row .cost-approve-list {
  width: 500px;
}
.cost-row-colum {
  width: 860px;
}
.cost-sub-title {
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  padding-left: 60px;
  margin-top: 10px;
}
.cost-sub-title .line {
  width: 860px;
  height: 1px;
  background: #dadada;
  margin-left: 20px;
}
.margin100 {
  margin-left: 60px;
}
/deep/ .el-dialog__body {
  padding: 10px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
/deep/ .el-dialog__footer {
  padding: 0px 20px 20px;
  text-align: right;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.header-sty {
  width: 100%;
  height: 65px;
  line-height: 65px;
}
.txt-sty {
  color: #323233;
  font-size: 20px;
  float: left;
  width: 90%;
  text-align: center;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input[type='number'] {
  -moz-appearance: textfield;
}
.demo-ruleForm {
  display: flex;
  flex-wrap: wrap;
}
</style>
<style>
.reimbursement-check /deep/.el-checkbox__label {
  display: none !important;
}
.twoAn {
  color: #4fa1a4;
  font-size: 14px;
  margin-right: 10px;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 10px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.select-box {
  display: flex;
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.addPeople {
  width: 84px;
  height: 28px;
  margin-top: 5px;
  border: 1px solid #4fa1a4;
  text-align: center;
  line-height: 28px;
  color: #4fa1a4;
}
/* .mt20 .el-form-item__content {
  width: 830px;
} */
</style>

<style lang="less" scoped>
.content {
  padding: 0px;
  margin: 0px;
  // padding-bottom: 60px;
  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;
    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }
    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
    .approve-btn{
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      line-height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      right: 16px;
      top: 6px;
    }
    .approve-tag{
      font-size: 12px;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      line-height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      right: 16px;
      top: 6px;
    }
  }
  .form-box {
    margin-top: 4px;
    text-align: left;
    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
    }
    .form-item-box {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 15px;
    }
    .el-col-12 {
      margin-bottom: 14px;
    }
    .el-form-item {
      margin-bottom: 0px;
    }
    .el-input,
    .el-select {
      width: 314px;
    }
    .age-are-box {
      display: flex;
      align-items: center;
      .el-input {
        width: 142px;
      }
      span {
        margin: 0px 8px;
      }
    }
    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;
    }
  }

  /deep/ .el-form-item__error {
    padding-top: 0px;
  }
  .el-button--primary {
    color: #ffffff;
  }

  .file-list-box {
    display: flex;
    // justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 32px;
    .upload-file-box {
      max-width: calc(100% - 132px - 16px);
    }
    .btn-box {
      position: absolute;
      width: 180px;
      margin-left: 16px;
      height: 32px;
      left: 430px;
    }
  }
  .operte-btns {
    background: #fff;
    margin-top: 2px;
    display: flex;
    justify-content: center;
    padding: 25px 0;
  }

  .operte-btns .btn {
    padding: 5px 18px;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    cursor: pointer;
    margin-right: 10px;
  }

  .operte-btns .btn.save {
    border: 1px solid rgba(79, 161, 164, 1);
    color: rgba(79, 161, 164, 1);
    cursor: pointer;
  }

  .operte-btns .btn.submit {
    border: 1px solid rgba(79, 161, 164, 1);
    background: rgba(79, 161, 164, 1);
    color: #fff;
    cursor: pointer;
  }
}
/deep/ .el-upload__tip {
  line-height: 1;
  margin-top: 8px;
}
.sub-title {
  line-height: 28px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.sub-operate-add {
  color: #4fa1a4;
  margin-left: 14px;
  cursor: pointer;
}
.sub-operate-add2 {
  position: absolute;
  right: 0px;
  top: -35px;
}
.sub-operate-add3 {
  position: absolute;
  right: 30px;
  top: 5px;
}
/deep/.el-select-dropdown .el-select-dropdown__item {
  color: #212121;
}
/deep/ .el-upload-list__item {
  // width
  max-width: 430px;
}
</style>

<template>
  <div class="content">
    <div class="title-box">
      <el-button type="default" size="small" @click="$router.go(-1)">返回</el-button>
      <span>{{ isAudit?'审批详情':disabled? '查看资料' :txt }}</span>
      <el-tag v-if="$route.query.isAudit" class="approve-tag" :type="type[approveState]" size="small" >{{ approveStateObj[approveState] }}</el-tag>
    </div>
    <el-form :model="ruleForm" ref="ruleForm" label-width="150px" class="demo-ruleForm mb54">
      <!--start 基础资料 -->
      <div class="back-color-fff form-box">
        <span class="form-title">基础信息</span>
        <div class="form-item-box">
          <el-row>
            <el-col :span="12"
              ><el-form-item label="公司名称" prop="tenantGuid">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>公司名称</span>
                </span>
                <el-select
                  v-model="ruleForm.tenantGuid"
                  :disabled="disabled || !!$route.query.guid"
                  placeholder="请选择"
                  filterable
                  class="w300"
                  @change="tenantChange"
                >
                  <el-option
                    v-for="item in tenantList"
                    :key="item.sendTenantGuid"
                    :label="item.sendTenantName"
                    :value="item.sendTenantGuid"
                  >
                  </el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="12"
              ><el-form-item label="医疗机构标准名称" prop="medName">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>医疗机构标准名称</span>
                </span>
                <el-input v-model="ruleForm.medName" :disabled="disabled" @blur="checkName('medName')" placeholder="请输入" class="w300"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"
              ><el-form-item prop="markers" style="width: 450px">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>标注位置</span>
                </span>
                <div class="map-a-sty" v-if="!ruleForm.markers && !disabled" @click="showMap">
                  <i class="el-icon-plus"></i> 选择地图
                </div>
                <div v-if="ruleForm.markers && !disabled" class="map-a-sty" @click="showMap">
                  <i class="el-icon-plus"></i> 重新选择
                </div>
                <div v-if="ruleForm.markers && ruleForm.markers.lat">
                  经度：{{ ruleForm.markers.lng.toFixed(8) || '' }}，纬度：{{ ruleForm.markers.lat.toFixed(8) || '' }}
                </div>
                <div v-else-if="disabled">-</div>
                <div v-if="!disabled" class="fontC-4fa1a4">提示：请确认定位准确，以免影响客户拜访定位</div>
              </el-form-item></el-col
            >
            <el-col :span="12"
              ><el-form-item prop="addressList">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>所属区域</span>
                </span>
                <el-cascader
                  placeholder="请选择"
                  @change="handleAddress"
                  ref="cascaderFirst"
                  v-model="ruleForm.addressList"
                  :disabled="disabled"
                  :options="options"
                  class="w300"
                ></el-cascader> </el-form-item
            ></el-col>
            <el-col :span="12"
              ><el-form-item label="详细地址" prop="address">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>详细地址</span>
                </span>
                <el-input
                  type="textarea"
                  v-model="ruleForm.address"
                  :disabled="disabled"
                  placeholder="请输入"
                  class="w300"
                ></el-input> </el-form-item
            ></el-col>
            <el-col :span="12"
              ><el-form-item label="其他名称" prop="medStandardName">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>其他名称</span>
                </span>
                <el-input
                  v-model="ruleForm.medStandardName"
                  :disabled="disabled"
                  @blur="checkName('medStandardName')"
                  class="w300"
                  placeholder="请输入"
                ></el-input> </el-form-item
            ></el-col>
            <el-col :span="12"
              ><el-form-item label="机构级次" prop="orgRank">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>机构级次</span>
                </span>
                <el-select v-model="ruleForm.orgRank" :disabled="disabled" placeholder="请选择" class="w300">
                  <el-option v-for="item in orgRankList" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="12"
              ><el-form-item label="机构等级" prop="orgGrade">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>机构等级</span>
                </span>
                <el-select v-model="ruleForm.orgGrade" :disabled="disabled" placeholder="请选择" class="w300">
                  <el-option v-for="item in getCodeListByKey('医院等次')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="12"
              ><el-form-item label="机构类别" prop="orgType">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>机构类别</span>
                </span>
                <el-select v-model="ruleForm.orgType" :disabled="disabled" placeholder="请选择" class="w300">
                  <el-option
                    v-for="item in getCodeListByKey('医院分类')"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select> </el-form-item
            ></el-col>

            <el-col :span="12"
              ><el-form-item label="机构性质" prop="medType">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>机构性质</span>
                </span>
                <el-select v-model="ruleForm.medType" :disabled="disabled" placeholder="请选择" class="w300">
                  <el-option v-for="item in medTypeList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select> </el-form-item
            ></el-col>
            <!-- <el-col :span="12">
              <el-form-item label="启用状态">
                <el-radio-group class="w300" :disabled="disabled" v-model="ruleForm.bizState">
                  <el-radio label="Y">启用</el-radio>
                  <el-radio label="S">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col> -->
            <el-col :span="12"
              ><el-form-item label="营业收入" prop="income">
                <el-input
                  v-model="ruleForm.income"
                  :disabled="disabled"
                  type="number"
                  class="w300"
                  placeholder="请输入"
                ></el-input> </el-form-item
            ></el-col>
            <el-col :span="12"
              ><el-form-item label="行业地位" prop="tradeLevel">
                <el-select v-model="ruleForm.tradeLevel" :disabled="disabled" placeholder="点击选择" class="w300">
                  <el-option v-for="item in tradeLevelList" :key="item.value" :label="item.name" :value="item.value">
                  </el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="12"
              ><el-form-item label="医疗保险定点机构" prop="isMedicalInsurance">
                <el-select v-model="ruleForm.isMedicalInsurance" placeholder="请选择" class="w300">
                  <el-option v-for="item in ynList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="12"
              ><el-form-item label="新农合定点机构" prop="isNewCountryCooperation">
                <el-select v-model="ruleForm.isNewCountryCooperation" :disabled="disabled" placeholder="请选择" class="w300">
                  <el-option v-for="item in ynList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="12"
              ><el-form-item label="需求科室" prop="medDeptGuids">
                <el-cascader
                  collapse-tags
                  placeholder="请选择科室"
                  class="w300"
                  v-model="ruleForm.medDeptGuids"
                  :disabled="disabled"
                  :options="departList"
                  clearable
                  :props="cascaderProps"
                  filterable
                ></el-cascader> </el-form-item
            ></el-col>
            <el-col :span="12"
              ><el-form-item label="累计拜访次数" prop="visitCount">
                <el-input
                  placeholder="请输入累计拜访次数"
                  type="number"
                  v-model="ruleForm.visitCount"
                  :disabled="disabled"
                  class="w300"
                ></el-input> </el-form-item
            ></el-col>
          </el-row>

          <el-row style="padding-top:8px">
            <el-col :span="12"
              ><el-form-item label="竞品情况" prop="competingGoodsInfo">
                <el-input
                  type="textarea"
                  v-model="ruleForm.competingGoodsInfo"
                  :disabled="disabled"
                  placeholder="请输入"
                  class="w300"
                ></el-input> </el-form-item
            ></el-col>
            <el-col :span="12"
              ><el-form-item label="业务范围" prop="bizArea">
                <el-input
                  type="textarea"
                  v-model="ruleForm.bizArea"
                  :disabled="disabled"
                  class="w300"
                  placeholder="请输入"
                ></el-input> </el-form-item
            ></el-col>
          </el-row>
        </div>
      </div>
      <!--end 基础资料  -->

      <!--start 联系人 -->
      <div class="back-color-fff form-box">
        <span class="form-title">联系人信息</span>
        <div class="form-item-box">
          <el-row>
            <el-col :span="12"
              ><el-form-item label="医院联系人" prop="contacts">
                <span slot="label">
                  <span>医院联系人</span>
                </span>
                <el-input
                  type="text"
                  ref="contactsRef"
                  @input="ruleForm.contacts = ruleForm.contacts.replace(/[^\a-\z\A-\Z\u4E00-\u9FA5]/g, '')"
                  @blur="nameBlur(ruleForm.contacts, ruleForm, 'contacts')"
                  :disabled="disabled"
                  v-model="ruleForm.contacts"
                  class="w300"
                  placeholder="请输入"
                ></el-input> </el-form-item
            ></el-col>

            <el-col :span="12"
              ><el-form-item label="联系人性别" prop="contactSex">
                <span slot="label">
                  <span>联系人性别</span>
                </span>
                <el-select v-model="ruleForm.contactSex" :disabled="disabled" placeholder="请选择" class="w300">
                  <el-option v-for="item in sexList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="12"
              ><el-form-item label="手机号码" prop="contactTel">
                <el-input
                  @input="ruleForm.contactTel = ruleForm.contactTel.replace(/[^\d\-\d]/g, '')"
                  v-model="ruleForm.contactTel"
                  :disabled="disabled"
                  class="w300"
                  maxlength="13"
                  placeholder="请输入"
                ></el-input> </el-form-item
            ></el-col>

            <el-col :span="12"
              ><el-form-item label="建档时间" required>
                <el-form-item prop="inputDate">
                  <el-date-picker
                    type="date"
                    placeholder="选择日期"
                    v-model="ruleForm.inputDate"
                    :disabled="disabled"
                    class="w300"
                  ></el-date-picker>
                </el-form-item> </el-form-item
            ></el-col>

            <el-col :span="24"><el-form-item label="业务指派人员">
              <div class="addPeople" v-if="!disabled" @click="popupBox()"><i class="el-icon-plus"></i> 添加人员</div>
                <!-- 人员表格 -->
                <ChoosePerson
                 ref="choosePerson"
                 :showChoosePerson.sync="showChoosePerson"
                 :areaData="areaData"
                 :serviceTenants="serviceTenants"
                 :serviceTenantGuid="serviceTenantGuid"
                 :dialogLoading="dialogLoading"
                 :list="belongStaffList"
                 @getPerson="getPerson"
                 >
                 </ChoosePerson>
                <!-- 人员表格 -->
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <!--end 联系人 -->
    </el-form>
    <!-- 按钮区域 -->
    <div class="submit-btn-box submit_btn_wrap" v-if="!isAudit">
      <el-button type="defalut" size="small" @click="back()">取消</el-button>
      <el-button type="primary" size="small" v-if="txt == '新增医院'" @click="submitForm(2)">提交</el-button>
      <el-button type="primary" size="small" v-if="txt != '新增医院'" @click="upDateForm">提交</el-button>
      <el-button type="primary" size="small" v-if="txt == '新增医院'" @click="submitForm(1)">添加下一个</el-button>
    </div>
    <div class="operte-btns back-color-fff" v-else>
      <el-button v-if="approveState=='A'" type="primary" size="small"  @click="toAudit()">审核</el-button>
      <el-button v-if="approveState=='Y'||approveState=='N'" type="primary" size="small"  @click="toAudit()">撤回重审</el-button>
      <el-button type="defalut" size="small"  @click="$router.go(-1)">返回</el-button>
    </div>

    <!-- 弹框区域 -->
    <el-dialog title="选择地图" :visible.sync="dialogVisible" width="980px">
      <dialogMap ref="refMap" :markers="ruleForm.markers" @getMarkers="getMarkers" @close="close"></dialogMap>
    </el-dialog>
    <AuditDialog @closeAudit="closeAudit"></AuditDialog>
  </div>
</template>
<script>
import areaJson from '../../assets/js/china_address_v4.js';
import dialogMap from '../../components/dialogMap';
import recentDate from '@/uilt/recentDate';
import { removeDuplicates } from '@/uilt/tool';
import ChoosePerson from './components/ChoosePerson'
import AuditDialog from './components/AuditDialog'
import mixins from './components/mixins/detailMixins.js';
export default {
  components: {
    dialogMap,
    ChoosePerson,
    AuditDialog
  },
  mixins: [mixins],
  data() {
    return {
      shezArr: [],
      pages: {
        pageIndex: 1,
        pageSize: 10,
        totalRowss: 0,
      },
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalRowss: 0,
      },
      customerGuids: [],
      // 树状
      areaData: [],
      showChoosePerson: false, // 人员选择
      tenantList: [],
      serviceTenants: [],
      serviceTenantGuid: '',
      dialogLoading: false,
      currentMedSelect: [],
      joinDialog: false,
      txt: '',
      dialogVisible: false,
      options: areaJson,
      fullscreenLoading: false,
      personList: [],
      ruleForm: {
        tenantGuid: '',
        medName: '',
        medStandardName: '',
        createUserId: '',
        orgRank: '',
        orgGrade: '',
        orgType: '',
        contactSex: '',
        medType: '',
        region: '',
        province: '',
        city: '',
        district: '',
        address: '',
        contacts: '',
        contactTel: '',
        lng: '',
        lat: '',
        inputDate: recentDate.getNowDay(),
        addressList: [],
        venue: '',
        markers: { lat: '', lng: '' },
        manageDuration: '',
        areaMeasure: '',
        customerName: '',
        customerGuid: '',
        income: '',
        tradeLevel: '',
        isMedicalInsurance: '',
        isNewCountryCooperation: '',
        buyStaffName: '',
        medDeptGuids: [],
        visitCount: '',
        competingGoodsInfo: '',
        bizArea: '',
        bizState:'Y',//启用状态
      },
      departList: [],
      orgRankList: [],
      orgGradeList: [
        {
          value: '1',
          label: '甲等',
        },
        {
          value: '2',
          label: '乙等',
        },
        {
          value: '3',
          label: '丙等',
        },
      ],
      tradeLevelList: [
        {
          value: '领导者',
          label: '领导者',
        },
        {
          value: '具有影响力',
          label: '具有影响力',
        },
      ],
      sexList: [
        {
          value: '男',
          label: '男',
        },
        {
          value: '女',
          label: '女',
        },
      ],
      medTypeList: [
        {
          value: '国有',
          label: '国有',
        },
        {
          value: '私营',
          label: '私营',
        },
        {
          value: '合资',
          label: '合资',
        },
        {
          value: '合伙',
          label: '合伙',
        },
        {
          value: '股份',
          label: '股份',
        },
      ],
      ynList: [
        {
          value: '是',
          label: '是',
        },
        {
          value: '否',
          label: '否',
        },
      ],
      addressList: [],
      medPage: {
        pageIndex: 1,
        tenantGuid: '',
        pageSize: 10,
        customerName: '',
        // province: '',
        // city: '',
        // district: '',
        // approvalStates: ["Y", "U"],
        totalPage: 0,
        totalRows: 0,
      },
      cascaderProps: {
        //角色级联
        value: 'guid',
        label: 'deptName',
        children: 'childList',
        multiple: true,
        emitPath: false,
      },
      staffList: [],
      provinceOption: [],
      cityOption: [],
      districtOption: [],
      belongStaffList:[], // 指派人员列表
      changebelongStaffList:[], // 修改后的指派人员
      belongStaffs:[],
      type: {
        A: 'warning',
        Y: 'success',
        N: 'danger',
      },
      approveStateObj: {
        A: '待审批',
        Y: '合格',
        N: '不合格',
      },
      approveState:''
    };
  },
  computed: {},
  created() {
    this.getOrganisation();
    if (this.$route.query.guid) {
      this.txt = '编辑医院';
      //  this.getCustomerDetail();
      this.getCustomerDetail(this.$route.query.guid, () => {
        this.showSalesman();
      });
    } else {
      this.reset();
      if (this.$route.query.tenantGuid) {
        this.medPage.tenantGuid = this.$route.query.tenantGuid;
        this.getDepartList(this.$route.query.tenantGuid);
        this.getStaffList(this.$route.query.tenantGuid);
      }
    }
    if(this.$route.query.isAudit){
      this.approveState=this.$route.query.approveState||''
    }
    this.getTenantOperationRelList();

    this.getLevelList(2);
  },
  methods: {
    closeAudit(state){
      this.$router.go(-1)
      // this.approveState=state
      // this.$forceUpdate()
    },
    toAudit() {
      this.$root.$emit('auditDialog', {
        auditDialogVisible: true,
        title:'审批',
        // type,
        approveGuidList: [this.$route.query.approveGuid],
      });

    },
    getLevelList(type) {
      let that = this;
      that.api
        .get(
          `/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=${
            type == 1 ? '城市等级' : type == 2 ? '医院级别' : '会议类型'
          }`,
        )
        .then((resp) => {
          console.log(resp.data);
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            data.forEach((item) => {
              item.value = item.value;
            });
            type == 1
              ? (this.cityLevelList = data)
              : type == 2
              ? (this.orgRankList = data)
              : (this.meetingTypeList = data);
          }
        });
    },
    provinceChange(pr, type) {
      let self = this;
      self.cityOption = [];
      self.districtOption = [];
      if (type == 1) {
        self.ruleForm.city = '';
        self.ruleForm.district = '';
      }
      self.options.forEach((i) => {
        if (i.value == pr) {
          if (i.children != null && i.children != '') {
            i.children.forEach((j) => {
              self.cityOption.push(j);
            });
          }
        }
      });
    },
    cityChange(ci, type) {
      let self = this;
      console.log(self.cityOption);
      self.districtOption = [];
      if (type == 1) {
        self.ruleForm.district = '';
      }
      self.cityOption.forEach((i) => {
        if (i.value == ci) {
          if (i.children != null && i.children != '') {
            i.children.forEach((j) => {
              self.districtOption.push(j);
            });
          }
        }
      });
    },
    tenantChange() {
      let self = this;
      self.medPage.tenantGuid = self.ruleForm.tenantGuid;
      self.getDepartList(self.ruleForm.tenantGuid);
      self.getStaffList(self.ruleForm.tenantGuid);
    },
    getStaffList(tenantGuid) {
      // this.api
      //   .get(`/${serverConfig.msPersonnelService}/staff/get-staff-by-tenantGuid?tenantGuid=` + tenantGuid)
      //   .then((res) => {
      //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
      //       this.staffList = res.data.data;
      //     } else {
      //       this.$message.error(res.data.data.msg);
      //     }
      //   });
    },
    empty() {
      this.medPage = {
        pageIndex: 1,
        tenantGuid: '',
        pageSize: 10,
        customerName: '',
        // province: '',
        // city: '',
        // district: '',
        approvalStates: ['Y', 'U'],
        totalPage: 0,
        totalRows: 0,
      };
      this.addressList = [];
    },
    getDepartList(tenantGuid) {
      if (!tenantGuid) {
        this.$message.error('请选择公司名称！');
        return;
      }
      this.api.get(`/${serverConfig.msPersonnelService}/med-dept/get-tree?tenantGuid=` + tenantGuid).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.departList = res.data.data;
        } else {
          this.$message.error(res.data.data.msg);
        }
      });
    },
    checkMedBoxChange(val) {
      if (this.currentMedSelect.indexOf(val.guid) > -1) {
        this.currentMedSelect = [];
        this.currentMedSelect.push(val.guid);
        this.ruleForm.customerName = val.drugstoreName;
        this.ruleForm.customerGuid = val.guid;
      }
    },
    showMap() {
      this.dialogVisible = true;
    },
    getMarkers(marker) {
      this.dialogVisible = false;
      this.ruleForm.markers = marker;
      this.ruleForm.province = marker.province;
      this.ruleForm.city = marker.city;
      this.ruleForm.district = marker.district;
      this.ruleForm.address = marker.address;
      this.ruleForm.addressList = [marker.province, marker.city, marker.district];
      // 程序化回填addressList不会触发票联change,需同步重算venue,否则提交的venue仍是旧区域
      let venue = '';
      if (marker.province) {
        venue = this.province(marker.province);
      }
      if (marker.city) {
        venue = this.province(marker.province) + '/' + this.city(marker.city);
      }
      if (marker.district) {
        venue = this.province(marker.province) + '/' + this.city(marker.city) + '/' + this.district(marker.district);
      }
      this.ruleForm.venue = venue;
      this.provinceChange(this.ruleForm.province);
      this.cityChange(this.ruleForm.city);
      console.log('markermarker', marker);
    },
    close() {
      this.dialogVisible = false;
    },
    incres(area) {
      const checkedNodes = this.$refs['cascaderFirst'].getCheckedNodes();
      let arr = checkedNodes[0].pathNodes;
      let codeArr = [];
      arr.forEach((item) => {
        codeArr.push(item.data.value);
      });
      this.ruleForm.province = codeArr[0];
      this.ruleForm.city = codeArr[1];
      this.ruleForm.district = codeArr[2];
      let venue = '';
      if (codeArr) {
        if (codeArr[0]) {
          venue = this.province(codeArr[0]);
        }
        if (codeArr[1]) {
          venue = this.province(codeArr[0]) + '/' + this.city(codeArr[1]);
        }
        if (codeArr[2]) {
          venue = this.province(codeArr[0]) + '/' + this.city(codeArr[1]) + '/' + this.district(codeArr[2]);
        }
      }
      this.ruleForm.venue = venue;
    },
    province(val) {
      let pr = '';
      this.options.forEach(function (j) {
        if (j.value == val) {
          pr = j.label;
        }
      });
      return pr;
    },
    city(val) {
      let ci = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.value == val) {
              ci = j.label;
            }
          });
        }
      });
      return ci;
    },
    district(val) {
      let di = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.children != null && j.children != '') {
              j.children.forEach(function (n) {
                if (n.value == val) {
                  di = n.label;
                }
              });
            }
          });
        }
      });
      return di;
    },
    getCustomerDetail(guid, callBack) {
      let self = this;
      self.staffDetail = '';
      self.defaultCheckedKeys = [];
      self.api.get(`/${serverConfig.msCustomerService}/med/data/get/` + this.$route.query.guid).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.staffDetail = res.data.data;
          console.log(self.staffDetail);
          let marker = {
            lat: self.staffDetail.lat,
            lng: self.staffDetail.lng,
          };
          console.log(self.ruleForm.markers);
          let customerName = '';
          let customerGuid = '';
          if (self.staffDetail.customerList) {
            customerName = self.staffDetail.customerList[0].text;
            customerGuid = self.staffDetail.customerList[0].value;
          }
          let date = self.staffDetail.inputDate ? self.$moment(self.staffDetail.inputDate).format('YYYY-MM-DD') : null;
          this.ruleForm = {
            tenantGuid: self.staffDetail.tenantGuid,
            medName: self.staffDetail.medName,
            medStandardName: self.staffDetail.medStandardName,
            createUserId: self.staffDetail.createUserId,
            orgRank: self.staffDetail.orgRank,
            orgGrade: self.staffDetail.orgGrade,
            orgType: self.staffDetail.orgType,
            contactSex: self.staffDetail.contactSex,
            medType: self.staffDetail.medType,
            region: self.staffDetail.region,
            province: self.staffDetail.province,
            city: self.staffDetail.city,
            district: self.staffDetail.district,
            venue: self.staffDetail.venue,
            address: self.staffDetail.address,
            contacts: self.staffDetail.contacts,
            contactTel: self.staffDetail.contactTel,
            lng: self.staffDetail.lng,
            lat: self.staffDetail.lat,
            inputDate: date,
            addressList: [self.staffDetail.province, self.staffDetail.city, self.staffDetail.district],
            markers: marker,
            manageDuration: self.staffDetail.manageDuration,
            // areaMeasure: self.staffDetail.areaMeasure,
            customerName: customerName,
            customerGuid: customerGuid,
            income: self.staffDetail.income,
            tradeLevel: self.staffDetail.tradeLevel,
            isMedicalInsurance: self.staffDetail.isMedicalInsurance,
            isNewCountryCooperation: self.staffDetail.isNewCountryCooperation,
            buyStaffName: self.staffDetail.buyStaffName,
            medDeptGuids: self.staffDetail.medDeptGuids,
            visitCount: self.staffDetail.visitCount,
            competingGoodsInfo: self.staffDetail.competingGoodsInfo,
            bizArea: self.staffDetail.bizArea,
            bizState: self.staffDetail.bizState,
          };
          self.provinceChange(self.ruleForm.province);
          self.cityChange(self.ruleForm.city);
          self.getDepartList(self.ruleForm.tenantGuid);
          self.medPage.tenantGuid = self.ruleForm.tenantGuid;
          self.getStaffList(self.ruleForm.tenantGuid);
          this.getTenantOperationRelList();
          self.customerGuids.push(self.staffDetail.guid);
          console.log(self.customerGuids);
          //执行函数
          if (callBack) {
            callBack();
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    showSalesman(val) {
      console.log(val);
      let self = this;

      let query = {
        customerGuids: this.customerGuids,
        pageIndex: this.page.pageIndex,
        // 要把列表所有数据获取到
        pageSize: 10000,
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/med/get-belong-staff`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.belongStaffList = JSON.parse(JSON.stringify(res.data.data.records)) || [];
          this.changebelongStaffList = JSON.parse(JSON.stringify(res.data.data.records)) || [];
        } else {
          self.$message.error(res.data.data.msg);
        }
      });
    },
    reset() {
      this.txt = '新增医院';
      this.ruleForm = {
        medName: '',
        medStandardName: '',
        createUserId: '',
        orgRank: '',
        orgGrade: '',
        orgType: '',
        contactSex: '',
        medType: '',
        region: '',
        province: '',
        city: '',
        district: '',
        venue: '',
        address: '',
        contacts: '',
        contactTel: '',
        lng: '',
        lat: '',
        inputDate: recentDate.getNowDay(),
        addressList: [],
        markers: '',
        manageDuration: '',
        areaMeasure: '',
        customerName: '',
        customerGuid: '',
        income: '',
        tradeLevel: '',
        isMedicalInsurance: '',
        isNewCountryCooperation: '',
        buyStaffName: '',
        medDeptGuids: [],
        visitCount: '',
        competingGoodsInfo: '',
        bizArea: '',
        bizState:'Y',//启用状态
      };
      this.belongStaffList =  [];
      this.changebelongStaffList = []
      if(this.$refs.refMap){
        this.$refs.refMap.locationSearch=null
        this.$refs.refMap.searchList=[]
        this.$refs.refMap.mapType= 'bdMap'
        this.$refs.refMap.changeMap('bdMap')
      }
      if(this.$refs.choosePerson){
        this.$refs.choosePerson.departmentList=[]
      }
    },
    checkName(key) {
      let patrn = /^[\u4e00-\u9fffA-Za-z0-9()（）、〇]+$/g;
      if(key=='medName'&&this.ruleForm.medName){
        if (!patrn.test(this.ruleForm.medName)) {
          // 如果包含特殊字符返回false
          this.$message.error('医疗机构标准名称仅可输入中文、英文、数字、括号、顿号!');
          return;
        }else{
          this.existsCheckBlur('4')
        }
      }else if(key=='medStandardName'&&this.ruleForm.medStandardName){
        if (!patrn.test(this.ruleForm.medStandardName)) {
          // 如果包含特殊字符返回false
          this.$message.error('其他名称仅可输入中文、英文、数字、括号、顿号!');
           return ;
        }
      }
    },
    submitForm(type) {
      let self = this;
      if (!this.checkForm()) return;
      if (this.ruleForm.medName) {
        let patrn = /^[\u4e00-\u9fffA-Za-z0-9()（）、〇]+$/g;
        if (!patrn.test(this.ruleForm.medName)) {
          // 如果包含特殊字符返回false
          this.$message.error('医疗机构标准名称仅可输入中文、英文、数字、括号、顿号!');
          return ;
        }
      }
      if (this.ruleForm.medStandardName) {
        let patrn = /^[\u4e00-\u9fffA-Za-z0-9()（）、〇]+$/g;
        if (!patrn.test(this.ruleForm.medStandardName)) {
          // 如果包含特殊字符返回false
          this.$message.error('其他名称仅可输入中文、英文、数字、括号、顿号!');
          return ;
        }
      }
      let customerList = [];
      let cus = {
        text: self.ruleForm.customerName,
        value: self.ruleForm.customerGuid,
      };
      customerList.push(cus);
      let createUserName = '';
      let staffGuid = '';
      if (self.staffList) {
        self.staffList.forEach((i) => {
          if (i.userGuid == self.ruleForm.createUserId) {
            createUserName = i.staffName;
            staffGuid = i.guid;
          }
        });
      }
      let promise = {
        tenantGuid: self.ruleForm.tenantGuid,
        medName: self.ruleForm.medName,
        medStandardName: self.ruleForm.medStandardName,
        // createUserId: self.ruleForm.createUserId,
        createUserName: createUserName,
        staffGuid: staffGuid,
        orgGrade: self.ruleForm.orgGrade,
        orgRank: self.ruleForm.orgRank,
        orgType: self.ruleForm.orgType,
        medType: self.ruleForm.medType,
        province: self.ruleForm.province,
        city: self.ruleForm.city,
        district: self.ruleForm.district,
        venue: self.ruleForm.venue,
        address: self.ruleForm.address,
        contacts: self.ruleForm.contacts,
        contactTel: self.ruleForm.contactTel,
        lng: this.ruleForm.markers.lng,
        lat: this.ruleForm.markers.lat,
        // customerList: customerList,
        bizArea: self.ruleForm.bizArea,
        bizState: self.ruleForm.bizState,
        income: self.ruleForm.income,
        medDeptGuids: self.ruleForm.medDeptGuids,
        tradeLevel: self.ruleForm.tradeLevel,
        isMedicalInsurance: self.ruleForm.isMedicalInsurance,
        isNewCountryCooperation: self.ruleForm.isNewCountryCooperation,
        buyStaffName: self.ruleForm.buyStaffName,
        needOffice: self.ruleForm.needOffice,
        visitCount: self.ruleForm.visitCount,
        contactSex: self.ruleForm.contactSex,
        inputDate: self.ruleForm.inputDate,
        competingGoodsInfo: self.ruleForm.competingGoodsInfo,
        belongStaffs: this.changebelongStaffList
      };
      self.fullscreenLoading = true;

      self.api.postJson(`/${serverConfig.msCustomerService}/med/data/pc-add`, promise).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('提交成功');
          if (type == 1) {
            self.reset();
          } else {
            this.back();
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    upDateForm() {
      let self = this;
      if (!this.checkForm()) return;
      if (this.ruleForm.medName) {
        let patrn = /^[\u4e00-\u9fffA-Za-z0-9()（）、〇]+$/g;
        if (!patrn.test(this.ruleForm.medName)) {
          // 如果包含特殊字符返回false
          this.$message.error('医疗机构标准名称仅可输入中文、英文、数字、括号、顿号!');
          return ;
        }
      }
      if (this.ruleForm.medStandardName) {
        let patrn = /^[\u4e00-\u9fffA-Za-z0-9()（）、〇]+$/g;
        if (!patrn.test(this.ruleForm.medStandardName)) {
          // 如果包含特殊字符返回false
          this.$message.error('其他名称仅可输入中文、英文、数字、括号、顿号!');
          return ;
        }
      }
      let customerList = [];
      let cus = {
        text: self.ruleForm.customerName,
        value: self.ruleForm.customerGuid,
      };
      customerList.push(cus);
      let createUserName = '';
      let staffGuid = '';
      if (self.staffList) {
        self.staffList.forEach((i) => {
          if (i.userGuid == self.ruleForm.createUserId) {
            createUserName = i.staffName;
            staffGuid = i.guid;
          }
        });
      }
      let promise = {
        guid: self.$route.query.guid,
        tenantGuid: self.ruleForm.tenantGuid,
        medName: self.ruleForm.medName,
        // createUserId: self.ruleForm.createUserId,
        createUserName: createUserName,
        staffGuid: staffGuid,
        medStandardName: self.ruleForm.medStandardName,
        orgGrade: self.ruleForm.orgGrade,
        orgRank: self.ruleForm.orgRank,
        orgType: self.ruleForm.orgType,
        medType: self.ruleForm.medType,
        province: self.ruleForm.province,
        city: self.ruleForm.city,
        district: self.ruleForm.district,
        venue: self.ruleForm.venue,
        address: self.ruleForm.address,
        contacts: self.ruleForm.contacts,
        contactTel: self.ruleForm.contactTel,
        orgType: self.ruleForm.orgType,
        lng: this.ruleForm.markers.lng,
        lat: this.ruleForm.markers.lat,
        // customerList: customerList,
        bizArea: self.ruleForm.bizArea,
        bizState: self.ruleForm.bizState,
        income: self.ruleForm.income,
        medDeptGuids: self.ruleForm.medDeptGuids,
        tradeLevel: self.ruleForm.tradeLevel,
        isMedicalInsurance: self.ruleForm.isMedicalInsurance,
        isNewCountryCooperation: self.ruleForm.isNewCountryCooperation,
        buyStaffName: self.ruleForm.buyStaffName,
        needOffice: self.ruleForm.needOffice,
        visitCount: self.ruleForm.visitCount,
        contactSex: self.ruleForm.contactSex,
        inputDate: self.ruleForm.inputDate,
        competingGoodsInfo: self.ruleForm.competingGoodsInfo,
        belongStaffs: this.changebelongStaffList
      };

      self.fullscreenLoading = true;
      self.api.put(`/${serverConfig.msCustomerService}/med/data/pc-update`, promise).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('修改成功');
          this.back();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    checkForm() {
      if (!this.ruleForm.tenantGuid) {
        this.$message.error('请选择公司名称！');
        return false;
      }
      if (!this.ruleForm.medName) {
        this.$message.error('请输入医疗机构标准名称！');
        return false;
      }
      if (!this.ruleForm.markers || !this.ruleForm.markers.lat) {
        this.$message.error('请选择位置');
        return false;
      }
      if (!this.ruleForm.addressList.length) {
        this.$message.error('请选择区域');
        return false;
      }
      if (!this.ruleForm.address) {
        this.$message.error('请输入详细地址');
        return false;
      }
      if (!this.ruleForm.medStandardName) {
        this.$message.error('其他名称');
        return false;
      }

      if (!this.ruleForm.orgRank) {
        this.$message.error('请选择机构级次');
        return false;
      }
      if (!this.ruleForm.orgGrade) {
        this.$message.error('请选择机构等级');
        return false;
      }

      if (!this.ruleForm.orgType) {
        this.$message.error('请选择机构类别');
        return false;
      }
      if (!this.ruleForm.medType) {
        this.$message.error('请选择机构性质');
        return false;
      }
      // if (!this.ruleForm.contacts) {
      //   this.$message.error('请输入医院联系人');
      //   return false;
      // }
      // if (!this.ruleForm.contactSex) {
      //   this.$message.error('请选择联系人性别');
      //   return false;
      // }

      if (this.$NameCheck(this, this.ruleForm.contacts, 'contacts')) {
        // todo 姓名长度校验
        return false;
      }

      return true;
    },
    handleAddress() {
      const checkedNodes = this.$refs['cascaderFirst'].getCheckedNodes();
      let arr = checkedNodes[0].pathNodes;
      console.log(arr);
      let codeArr = [];
      arr.forEach((item) => {
        codeArr.push(item.data.value);
      });
      this.ruleForm.province = codeArr[0];
      this.ruleForm.city = codeArr[1];
      this.ruleForm.district = codeArr[2];
      let venue = '';
      if (codeArr) {
        if (codeArr[0]) {
          venue = this.province(codeArr[0]);
        }
        if (codeArr[1]) {
          venue = this.province(codeArr[0]) + '/' + this.city(codeArr[1]);
        }
        if (codeArr[2]) {
          venue = this.province(codeArr[0]) + '/' + this.city(codeArr[1]) + '/' + this.district(codeArr[2]);
        }
      }
      this.ruleForm.venue = venue;
    },
    back() {
      this.$router.go(-1);
    },
    /**
     * @param val 对应值
     * @param formObj 表单对象
     * @param fildeName 字段key
     */
    nameBlur(val, formObj, fildeName) {
      formObj[fildeName] = this.$NameCheckBlur(this, val, fildeName);
    },
    // 获取勾选的人员
    getPerson(res) {
      console.log(res);
      this.changebelongStaffList = res
    }
  },
};
</script>
